module.exports = __webpack_public_path__ + "img/pic_2_2.2e24e251.jpg";